import { render, staticRenderFns } from "./SpecificCommerce.vue?vue&type=template&id=b2aa6068&scoped=true&"
import script from "./SpecificCommerce.vue?vue&type=script&lang=js&"
export * from "./SpecificCommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aa6068",
  null
  
)

export default component.exports